import type {SuppliedFilterProviderOptions} from '@github-ui/filter'
import {DateFilterProvider, SelectFilterProvider} from '@github-ui/filter/providers'
import {AppsIcon, ArrowSwitchIcon, CalendarIcon} from '@primer/octicons-react'

function getCurrentDate() {
  return new Date().toLocaleDateString('en-us', {year: 'numeric', month: 'long', day: 'numeric'})
}

const ATTESTATIONS_FILTER_KEYS = {
  predicateType: {
    displayName: 'Predicate type',
    key: 'predicate-type',
    description: 'Filter attestations by predicate type',
    priority: 2,
    icon: AppsIcon,
  },
  created: {
    displayName: 'Created',
    key: 'created',
    description: 'Filter attestations by creation date',
    priority: 1,
    icon: CalendarIcon,
  },
}

const CREATED_VALUES = [
  {
    value: '@today',
    displayName: 'Today',
    priority: 1,
    icon: ArrowSwitchIcon,
  },
  {
    value: '@today-1d',
    displayName: 'Yesterday',
    priority: 2,
    icon: ArrowSwitchIcon,
  },
  {
    value: '>@today-1w',
    displayName: 'Past 7 days',
    priority: 3,
    icon: ArrowSwitchIcon,
  },
  {
    value: '>@today-30d',
    displayName: 'Past 30 days',
    priority: 4,
    icon: ArrowSwitchIcon,
  },
  {
    value: '>@today-1y',
    displayName: 'Past year',
    priority: 5,
    icon: ArrowSwitchIcon,
  },
  {
    value: () => {
      const now = new Date()
      return now.toISOString().slice(0, 10)
    },
    displayName: getCurrentDate(),
    priority: 6,
    icon: CalendarIcon,
  },
]

const PREDICATE_VALUES = [
  {value: 'provenance', displayName: 'provenance', priority: 1},
  {value: 'sbom', displayName: 'sbom', priority: 2},
]

const filterOptions: SuppliedFilterProviderOptions = {
  filterTypes: {multiKey: false, multiValue: false, valueless: false, exclusive: false},
}
export class PredicateTypeFilterProvider extends SelectFilterProvider {
  constructor() {
    super(ATTESTATIONS_FILTER_KEYS.predicateType, PREDICATE_VALUES, filterOptions)
  }
}
export class CreatedFilterProvider extends DateFilterProvider {
  constructor() {
    super(ATTESTATIONS_FILTER_KEYS.created, CREATED_VALUES, filterOptions)
  }
}
